@if (teamMemberCustomFields && teamMemberCustomFields.length > 0) {
<div class="custom-filters-toolbar w-100">
  <div class="row g-3">
    @for (field of teamMemberCustomFields; track field.id) {
    <div class="col-md-4">
      <div class="custom-filter-group">
        <span class="custom-filter-label">{{ field.name }}</span>

        @if (field.type === 'text') {
        <mat-form-field appearance="outline" class="filter-field-full" subscriptSizing="dynamic">
          <mat-select [name]="'filter_cf_' + field.id" [(ngModel)]="filters.custom[field.id]"
            (selectionChange)="onFilterChange()" multiple placeholder="{{ 'generic.all' | translate }}">
            @for (val of getUniqueCustomValues(field); track val) {
            <mat-option [value]="val">{{ val }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        @if (field.type === 'boolean') {
        <mat-form-field appearance="outline" class="filter-field-full" subscriptSizing="dynamic">
          <mat-select [name]="'filter_cf_' + field.id" [(ngModel)]="filters.custom[field.id]"
            (selectionChange)="onFilterChange()">
            <mat-option value="ALL">{{ 'generic.all' | translate }}</mat-option>
            <mat-option value="YES">{{ 'generic.answers.yes' | translate }}</mat-option>
            <mat-option value="NO">{{ 'generic.answers.no' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
        }

        @if (field.type === 'number') {
        <div class="numeric-filter-range d-flex align-items-center gap-2 w-100">
          <mat-form-field appearance="outline" class="flex-grow-1" subscriptSizing="dynamic">
            <mat-label>Min</mat-label>
            <input matInput type="number" [name]="'filter_cf_min_' + field.id"
              [(ngModel)]="filters.custom[field.id].min" (keyup)="onFilterChange()" (change)="onFilterChange()">
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1" subscriptSizing="dynamic">
            <mat-label>Max</mat-label>
            <input matInput type="number" [name]="'filter_cf_max_' + field.id"
              [(ngModel)]="filters.custom[field.id].max" (keyup)="onFilterChange()" (change)="onFilterChange()">
          </mat-form-field>
        </div>
        }

        @if (field.type === 'date') {
        <div class="numeric-filter-range d-flex align-items-center gap-2 w-100">
          <mat-form-field appearance="outline" class="flex-grow-1" subscriptSizing="dynamic">
            <mat-label>Dal</mat-label>
            <input matInput [matDatepicker]="pickerMin" [name]="'filter_cf_min_' + field.id"
              [(ngModel)]="filters.custom[field.id].min" (dateChange)="onFilterChange()">
            <mat-datepicker-toggle matSuffix [for]="pickerMin"></mat-datepicker-toggle>
            <mat-datepicker #pickerMin></mat-datepicker>
            <mat-hint>DD/MM/YYYY</mat-hint>
          </mat-form-field>
          <mat-form-field appearance="outline" class="flex-grow-1" subscriptSizing="dynamic">
            <mat-label>Al</mat-label>
            <input matInput [matDatepicker]="pickerMax" [name]="'filter_cf_max_' + field.id"
              [(ngModel)]="filters.custom[field.id].max" (dateChange)="onFilterChange()">
            <mat-datepicker-toggle matSuffix [for]="pickerMax"></mat-datepicker-toggle>
            <mat-datepicker #pickerMax></mat-datepicker>
            <mat-hint>DD/MM/YYYY</mat-hint>
          </mat-form-field>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
}
